import { Button, Form, Input, Modal } from 'antd';
import { App } from 'antd';
import React, { useEffect, useState } from 'react';
import { updateCustomer } from 'api/customers';
import { getData } from 'utils';
import { captureException } from 'utils/errors';
import { getHttpErrorMessage } from 'utils/http';

function DietaryPreferencesModal({ open, customer, onClose, onSuccess }) {
  const [loading, setLoading] = useState(false);
  const [form] = Form.useForm();
  const { message } = App.useApp();

  useEffect(() => {
    if (open && customer) {
      form.setFieldsValue({
        dietary_notes: customer.dietary_notes || '',
      });
    }
  }, [open, customer, form]);

  const handleClose = () => {
    form.resetFields();
    onClose();
  };

  const handleSubmit = (values) => {
    setLoading(true);
    updateCustomer(customer.id, { dietary_notes: values.dietary_notes?.trim() || null })
      .then((res) => {
        const data = getData(res)?.data ?? getData(res) ?? res?.data ?? res;
        onSuccess?.(data);
        message.success('Dietary preferences updated');
        handleClose();
      })
      .catch((e) => {
        captureException(e);
        message.error(getHttpErrorMessage(e));
      })
      .finally(() => setLoading(false));
  };

  return (
    <Modal
      title="Dietary Preferences"
      open={open}
      onCancel={handleClose}
      footer={null}
      destroyOnClose
    >
      <Form form={form} layout="vertical" onFinish={handleSubmit}>
        <Form.Item
          name="dietary_notes"
          label="Notes"
          extra="e.g. Vegetarian, no nuts, gluten-free"
        >
          <Input.TextArea rows={4} placeholder="Enter dietary preferences, allergies, or restrictions..." />
        </Form.Item>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <Button onClick={handleClose}>Cancel</Button>
          <Button type="primary" htmlType="submit" loading={loading}>
            Save
          </Button>
        </div>
      </Form>
    </Modal>
  );
}

export default DietaryPreferencesModal;
